export const pendingRecentlyAddedCompanies = (
  recentlyAddedCompanies = [],
  summaryRows = [],
  companyRows = []
) => {
  const summarizedCompanyIds = new Set(
    summaryRows.map((row) => row?.companyId).filter(Boolean)
  );
  const existingCompanyIds = new Set(
    companyRows.map((row) => row?.companyId || row?.id).filter(Boolean)
  );

  return recentlyAddedCompanies.filter(
    (company) =>
      company?.companyId &&
      existingCompanyIds.has(company.companyId) &&
      !summarizedCompanyIds.has(company.companyId)
  );
};
